"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberNode = void 0;
exports.numberNode = {
    hasChildNodes: false,
    getEvaluatorFunction: ({ node }) => {
        return () => ({
            node,
            inputs: [],
            output: { error: null, result: node.value },
        });
    },
};
//# sourceMappingURL=number.js.map